import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4bcac0cb&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4bcac0cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcac0cb",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SetupSidebar: require('/var/jenkins_home/workspace/prod-web-xfans/components/setup/SetupSidebar.vue').default})
